import { useSelector } from "react-redux";
import status from "../constants/actionStatus";

/**
 * get list of all courses content.
 * @returns {*}
 */
export default function useCourseContent(courseId, subjectId, topicId, refresh) {
    const courseContent = useSelector((state) => state.courseContent);
    const isLoading = courseContent && courseContent.status === status.PENDING;
    const { courseContent: content } = courseContent;
    return {
        content,
        isLoading,
    };
}
